import { render, staticRenderFns } from "./ClientRepresentatives.vue?vue&type=template&id=0f1916ed&"
import script from "./ClientRepresentatives.vue?vue&type=script&lang=js&"
export * from "./ClientRepresentatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports